import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { TechniciansProvider } from './TechniciansContext';
import { SkillsProvider } from './SkillsContext';
import { OnCallsProvider } from './OnCallsContext';
import { AbsencesProvider } from './AbsencesContext';

const DataContext = createContext(null);

export const useDataFilter = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useDataFilter must be used within a DataProvider');
  }
  return context;
};

export const DataProvider = ({ children }) => {
  const { currentUser } = useAuth();
  const [isInitialized, setIsInitialized] = useState(false);

  // Nettoyer les données quand l'utilisateur se déconnecte
  useEffect(() => {
    if (!currentUser?.id) {
      console.log('👤 DataProvider - Pas d\'utilisateur connecté, réinitialisation du filtre');
      setIsInitialized(false);
    } else {
      console.log('👤 DataProvider - Utilisateur connecté, initialisation du filtre');
      setIsInitialized(true);
    }
  }, [currentUser?.id]);

  // Fonction d'initialisation manuelle
  const initializeFilter = useCallback((user) => {
    console.log('🔄 DataProvider - Initialisation du filtre pour:', user?.email || 'utilisateur inconnu');
    setIsInitialized(true);
  }, []);

  const value = {
    filter: {
      isInitialized
    },
    initializeFilter
  };

  return (
    <DataContext.Provider value={value}>
      <TechniciansProvider>
        <SkillsProvider>
          <OnCallsProvider>
            <AbsencesProvider>
              {children}
            </AbsencesProvider>
          </OnCallsProvider>
        </SkillsProvider>
      </TechniciansProvider>
    </DataContext.Provider>
  );
}; 